import { StoreDealGuide } from '../components/StoreDealGuide';
import { StoreDealTitle } from '../components/StoreDealTitle';
import { useStoreDealBannerService } from '../services/useStoreDealBannerService';

export const StoreDealBannerContainer = () => {
  const { store_deal_banner, onClickTitle } = useStoreDealBannerService();
  return (
    <div>
      {store_deal_banner?.guide_text && <StoreDealGuide text={store_deal_banner.guide_text} />}
      {store_deal_banner?.title && <StoreDealTitle text={store_deal_banner.title} onClick={onClickTitle} />}
    </div>
  );
};
